import { render, staticRenderFns } from "./DemoDatatableRowSelection.vue?vue&type=template&id=b9e04264&"
import script from "./DemoDatatableRowSelection.vue?vue&type=script&lang=js&"
export * from "./DemoDatatableRowSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VChip,VDataTable,VImg})
